import React from "react";
import { View } from 'react-native'
import Text from "theme/Text";
import { ThemedBadgeStyles } from 'styles/components/atoms/ThemedBadge'
import isEqual from 'react-fast-compare'


const ThemedBadge = ( { value = null, textStyle = null, containerStyle = null } ) => {
	
	const viewStyle = [
		ThemedBadgeStyles.container,
		containerStyle
	]
	
	const viewTextStyle = [ ThemedBadgeStyles.text, textStyle ]
	
	return (
		<View style={ viewStyle }>
			<Text style={ viewTextStyle }>
				
				{ value }
			</Text>
		</View>
	)
}

export default React.memo( ThemedBadge, isEqual );
